export const GLOBAL_EXPERIMENT_KEY = 'experiment-a';

// Reserved for future use of experiments
export const EXPERIMENT_VARIANTS = {
  [GLOBAL_EXPERIMENT_KEY]: {
    EXPERIMENT_VARIANT_A: 'control',
    EXPERIMENT_VARIANT_B: 'variant_b',
    EXPERIMENT_VARIANT_C: 'variant_c'
  }
};
